<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <h1>Provision History</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Provision History</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="pt-3">
          <div class="card">
            <div
              class="card-header py-3"
              v-if="!_.isEmpty(list.data) && is_loading == false"
            >
              <a
                href="javascript:void(0)"
                class="btn btn-info"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter" :class="showFilter ? 'icon-up' : ''"></i>Filter
              </a>
            </div>

            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>

            <form @submit.prevent="getFilterData()" method="GET" novalidate>
              <div class="card-body" v-if="showFilter">
                <div class="row">
                  <!-- MAC ID Filter -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="col-form-label" for="macID">MAC ID</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="macID"
                          name="macID"
                          v-model="filter.mac"
                          class="form-control"
                          placeholder="Enter MAC ID"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Activation Status Filter -->
                  <div class="col-md-6 form-group">
                    <label class="col-form-label" for="status">Activation Status</label>
                    <el-select
                      class="w-100"
                      v-model="filter.activation_status"
                      placeholder="Select status"
                      clearable
                      :class="{ 'has-error': errors.has('activation_status') }"
                      id="status"
                      name="activation_status"
                    >
                      <el-option label="Due Activation" value="Due Activation" />
                      <el-option label="Activated" value="Activated" />
                      <el-option label="De-Activated" value="De-Activated" />
                    </el-select>
                  </div>

                  <!-- Search and Reset Buttons -->
                  <div class="col-md-12 text-right">
                    <button type="submit" class="btn mr-3">
                      <i class="icon-search"></i> Search
                    </button>
                    <button type="reset" class="btn btn-outline" @click="resetFilter()">
                      <i class="icon-refresh"></i> Reset
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <div class="card-body">
              <div v-if="!_.isEmpty(list.data) && is_loading == false">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Account ID</th>
                        <th>MAC ID</th>
                        <th>Email</th>
                        <th>Activation Status</th>
                        <th>Reason</th>
                        <th>Sub Reason</th>
                        <th>Action By</th>
                        <th>Created At</th>
                      </tr>
                    </thead>
                    <tbody class="list">
                      <tr v-for="(val, index) in list.data" :key="index">
                        <td>{{ val.account_id }}</td>
                        <td>{{ val.mac }}</td>
                        <td>{{ val.email }}</td>
                        <td style="width: 170px">
                          <div v-if="val.activation_status == 'Due Activation'">
                            <span class="badge badge-secondary">Due Activation</span>
                          </div>
                          <div v-else-if="val.activation_status == 'Activated'">
                            <span class="badge badge-success">Activated</span>
                          </div>
                          <div v-else-if="val.activation_status == 'De-Activated'">
                            <span class="badge badge-danger">De-Activated</span>
                          </div>
                        </td>
                        <td>{{ val.reason || ' ' }}</td>
                        <td>{{ val.sub_reason || ' ' }}</td>
                        <td>{{ val.creator.name || ' ' }}</td>
                        <td>{{ val.created_at }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="mt-3 text-right d-block d-sm-none px-3">
                  Swipe <i class="icon-swipe"></i>
                </div>
              </div>
              <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
                <div class="no-data">
                  <img src="/assets/images/no-data.svg" alt="" />
                  <h3>No data found!</h3>
                </div>
              </div>
            </div>

            <div :class="{ 'card-footer': list.total > list.per_page }">
              <vue-pagination
                :pagination="list"
                v-if="list.total > list.per_page"
                @paginate="reload()"
              ></vue-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { isEmpty } from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "ProvisionHistory",
  metaInfo: {
    title: "Provision History | Dotlines",
  },
  components: {
    VuePagination,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
      data: []
    },
    api_url: "",
    showFilter: false,
    filter: {
      mac: "",
      activation_status: "",
    },
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
  }),
  watch: {
    "$route.query"() {
      this.reload();
    },
  },
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/provision-histories";
    this.initialize();
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    async initialize() {
      this.is_loading = true;

      // Get filter values from route query
      if ("mac" in this.$route.query) {
        this.filter.mac = this.$route.query.mac;
        this.showFilter = true;
      } else {
        this.filter.mac = "";
      }

      if ("activation_status" in this.$route.query) {
        this.filter.activation_status = this.$route.query.activation_status;
        this.showFilter = true;
      } else {
        this.filter.activation_status = "";
      }

      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response && error.response.status === 403) {
            this.has_permission = false;
          }
        });

      this.is_loading = false;
    },

    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response && error.response.status === 403) {
            this.has_permission = false;
          }
        });
      
      this.$router
        .push({
          path: this.$route.fullPath,
          query: {
            mac: this.filter.mac,
            activation_status: this.filter.activation_status,
          },
        })
        .catch(() => {});
      
      this.is_loading = false;
    },

    reload: function () {
      this.is_loading = true;
      
      if ("mac" in this.$route.query) {
        this.filter.mac = this.$route.query.mac;
        this.showFilter = true;
      } else {
        this.filter.mac = "";
      }

      if ("activation_status" in this.$route.query) {
        this.filter.activation_status = this.$route.query.activation_status;
        this.showFilter = true;
      } else {
        this.filter.activation_status = "";
      }

      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response && error.response.status === 403) {
            this.has_permission = false;
          }
        })
        .finally(() => {
          this.is_loading = false;
        });
    },

    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async resetFilter() {
      this.is_loading = true;
      this.filter = {
        mac: "",
        activation_status: "",
      };

      this.$router
        .push({
          path: this.$route.path,
          query: {},
        })
        .catch(() => {});

      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response && error.response.status === 403) {
            this.has_permission = false;
          }
        });

      this.is_loading = false;
    },
  },
};
</script>

<style scoped>
.modal {
  z-index: 9999;
}
</style>